__turbopack_context__.v({
  "acountLink": "styles-module-scss-module__uDQqOq__acountLink",
  "agreeField": "styles-module-scss-module__uDQqOq__agreeField",
  "banner": "styles-module-scss-module__uDQqOq__banner",
  "button": "styles-module-scss-module__uDQqOq__button",
  "checkbox": "styles-module-scss-module__uDQqOq__checkbox",
  "half": "styles-module-scss-module__uDQqOq__half",
  "input": "styles-module-scss-module__uDQqOq__input",
  "label": "styles-module-scss-module__uDQqOq__label",
  "link": "styles-module-scss-module__uDQqOq__link",
  "root": "styles-module-scss-module__uDQqOq__root",
});
